export const whatsNewData = [
  {
    id: 1,
    title: "I-SWIPE TOUCH GESTURE CONTROLS",
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ism-0012.webp?alt=media&token=ee6af56c-1edf-4ed6-ba04-dc77e3da3d32",
  },
  {
    id: 2,
    title: "AURA HEX GRILLE",
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0001.webp?alt=media&token=cf29f486-f60e-451c-b09c-947e9e76fa12",
  },
  {
    id: 3,
    title: "AURA BOLT ALLOY WHEELS",
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0006.jpg?alt=media&token=237633af-c6f5-4ade-a27f-f56d7f1d3066",
  },
  {
    id: 4,
    title: "AURA SCULPT BUMPERS",
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0004.webp?alt=media&token=f328db1b-7f45-4714-9b11-17ef2dee9d30",
  },
  {
    id: 5,
    title: "ALL NEW INTERIORS",
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-int-0002.webp?alt=media&token=29eff18b-ab87-4fca-a90a-88ed5f1e05a2",
  },
  {
    id: 6,
    title: "360* AROUND VIEW WITH WHEEL VIEW ",
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-saf-0010%20(1).webp?alt=media&token=927e536c-968e-475d-909f-de6139da585e",
  },
  
];
